<template>
  <v-card>
    <v-card-title>
      Telefones
    </v-card-title>
    <v-form
      ref="form"
      v-model="valid"
      @submit.prevent="adicionarContato"
    >
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-select
            v-model="tipo"
            dense
            outlined
            label="Tipo"
            :items="tiposDeNumero"
            item-text="title"
            item-value="value"
            :rules="[validators.select]"
          ></v-select>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-if="tipo === 2"
            v-model.trim="numero"
            v-mask="'(##) ####-####'"
            outlined
            dense
            label="Telefone Fixo"
            :rules="[validators.isTelefoneFixoValido]"
          ></v-text-field>

          <v-text-field
            v-else
            v-model.trim="numero"
            v-mask="'(##) #####-####'"
            outlined
            dense
            label="Celular"
            :rules="[validators.isTelefoneCelularValido]"
          ></v-text-field>
        </v-col>

        <v-col
          v-if="tipo === 2"
          cols="12"
          md="2"
        >
          <v-text-field
            v-model.trim="ramal"
            outlined
            dense
            label="Ramal"
          ></v-text-field>
        </v-col>

        <v-card-text>
          <v-btn
            v-if="!acessoPut"
            color="primary"
            type="submit"
            disabled
          >
            Criar
          </v-btn>
          <v-btn
            v-else
            color="primary"
            type="submit"
          >
            Criar
          </v-btn>
        </v-card-text>

        <v-col cols="12">
          <table-telefone
            v-model="connectionsDataLocale.telefones"
            :acesso-put="acessoPut"
          ></table-telefone>
        </v-col>
      </v-row>

      <v-btn
        v-if="!acessoPut"
        color="primary"
        class="me-3 mt-3 ml-3 mb-3"
        disabled
      >
        Salvar alterações
      </v-btn>
      <v-btn
        v-else
        color="primary"
        class="me-3 mt-3 ml-3 mb-3"
        @click="update"
      >
        Salvar alterações
      </v-btn>
      <v-btn
        outlined
        class="mt-3 mb-3"
        color="secondary"
        type="reset"
        @click.prevent="resetForm"
      >
        Cancelar
      </v-btn>
    </v-form>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiClose, mdiLinkVariant } from '@mdi/js'
import { select, required } from '@core/utils/validation'
import { isTelefoneCelularValido, isTelefoneFixoValido } from '@/utils/validation'
import TableTelefone from '@/components/tables/TableTelefone.vue'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  components: {
    TableTelefone,
  },
  props: {
    connectionsData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      numero: '',
      tipo: '',
      ramal: '',
      tipoContato: '',
    }
  },
  beforeMount() {
    if (!this.connectionsDataLocale.redesSociais) {
      this.connectionsDataLocale.redesSociais = {
        telegram: '',
        outro: '',
      }
    }
  },
  methods: {
    adicionarContato() {
      if (this.valid) {
        this.connectionsDataLocale.telefones.push({
          numero: this.numero,
          ramal: this.ramal,
          tipo: this.tipo,
          tipoContato: this.tipoContato,
        })
      } else {
        this.validate()
      }
    },

    update() {
      ColaboradorService.update(this.connectionsDataLocale)
    },
  },

  setup(props) {
    const tiposDeNumero = [
      { title: 'Celular', value: 1 },
      { title: 'Fixo', value: 2 },
    ]

    const connectionsDataLocale = ref(JSON.parse(JSON.stringify(props.connectionsData)))

    const resetForm = () => {
      connectionsDataLocale.value = JSON.parse(JSON.stringify(props.connectionsData))
    }

    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    // const socialAccounts = [
    //   {
    //     img: 'facebook.png',
    //     title: 'Facebook',
    //     connected: false,
    //   },
    //   {
    //     img: 'twitter.png',
    //     title: 'Twitter',
    //     link: 'https://twitter.com/theme_selection',
    //     username: '@Theme_Selection',
    //     connected: true,
    //   },
    //   {
    //     img: 'linkedin.png',
    //     title: 'Linkedin',
    //     link: 'https://www.linkedin.com/company/themeselection',
    //     username: '@ThemeSelection',
    //     connected: true,
    //   },
    //   {
    //     img: 'dribbble.png',
    //     title: 'Dribbble',
    //     connected: false,
    //   },
    //   {
    //     img: 'behance.png',
    //     title: 'Behance',
    //     connected: false,
    //   },
    // ]

    return {
      // socialAccounts,
      tiposDeNumero,
      connectionsDataLocale,
      resetForm,
      form,
      valid,
      validate,
      icons: {
        mdiClose,
        mdiLinkVariant,
      },
      validators: {
        isTelefoneFixoValido,
        isTelefoneCelularValido,
        select,
        required,
      },
    }
  },
}
</script>
